export default "__VITE_ASSET__DnSAeYdw__"